module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9o0FA"))).then(() => parcelRequire('iDabs'));